export default __webpack_public_path__ + "static/media/gallery-wip-bunny-ears_03.39c0453a.jpg";